import React from "react";
import Modal from "react-modal";

export function AssignToModal({
  isOpen,
  employeeID,
  newAssignTo,
  employeeName,
  onAssign,
  onClose,
}) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <form className="m-10">
        <div className="card">
          <div className="card-header">Assigned To</div>
          <div className="card-body">
            <div className="mb-3">
              {employeeID && newAssignTo ? (
                `Confirm Assign ticket to ${employeeName}?`
              ) : (
                <div>Please assign anyone first. </div>
              )}
            </div>
            <button
              type="button"
              className="btn btn-outline-primary mr-3"
              data-testid="button-assign-to"
              onClick={onAssign}
            >
              Assign
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
